module.exports = __webpack_public_path__ + "img/product_d.eb6be550.svg";